import { useEffect, useMemo } from 'react';
import { useQueryClient } from 'react-query';

import { fetchTravelBookingById } from './queries';
import type { TravelBooking } from './queries';
import { scheduleActiveOperationRecheck } from './activeOperationRecheckScheduler';

export { earliestActiveOperationRecheckBooking } from './activeOperationRecheckScheduler';

export function useActiveOperationRecheck(
  booking: TravelBooking | null | undefined,
  onBooking?: (booking: TravelBooking) => void,
) {
  const queryClient = useQueryClient();
  const timerBooking = useMemo(
    () =>
      booking
        ? {
            id: booking.id,
            activeOperationStatus: booking.activeOperationStatus,
            activeOperationRecheckAt: booking.activeOperationRecheckAt,
          }
        : null,
    [
      booking?.id,
      booking?.activeOperationStatus,
      booking?.activeOperationRecheckAt,
    ],
  );

  useEffect(
    () =>
      scheduleActiveOperationRecheck({
        booking: timerBooking,
        fetchBooking: fetchTravelBookingById,
        onBooking,
        queryClient,
      }),
    [onBooking, queryClient, timerBooking],
  );
}
